// Approved CoreX Waitlist Privacy Notice content (WAIT-5A).
// Exact, minimal, waitlist-scoped. No business location / legal-structure info.
export const PRIVACY_NOTICE = {
  title: "Waitlist Privacy Notice | CoreX Athlete Development",
  heading: "WAITLIST PRIVACY NOTICE",
  effectiveDate: "Effective date: June 27, 2026",
  // Documentation only — NEVER sent from the browser. Production backend stores
  // this via WAITLIST_PRIVACY_POLICY_VERSION=2026-06-27.
  version: "2026-06-27",
  backLabel: "BACK TO COREX",
  email: "privacy@corexathletedevelopment.com",

  intro:
    "CoreX Athlete Development collects the information you provide when joining the waitlist, including your name, email address, optional organization name, role, sport interests, and marketing consent. We may also collect limited information about how you reached the waitlist page, such as campaign tags and the page path.",
  purposesIntro: "We use this information to:",
  purposes: [
    "manage the CoreX waitlist;",
    "send launch updates and invitations;",
    "understand interest in CoreX; and",
    "improve our launch planning.",
  ],
  afterPurposes: [
    "We may use service providers to host, process, secure, and communicate with waitlist members. We provide them only with information reasonably necessary to perform those services.",
    "We do not sell your personal information.",
    "We retain waitlist information only as long as reasonably necessary for the purposes described above or to meet legal requirements.",
  ],
  contactIntro:
    "You may unsubscribe from emails at any time. To request access to, correction of, or deletion of your waitlist information, contact:",
  closing:
    "We may update this notice as CoreX develops. The effective date above will show when it was last revised.",
};
